import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ChevronDown } from 'lucide-react';

const SponsorshipInfo = () => {
  const flyers = [
    'https://i.postimg.cc/RhG7BPBw/flyer.png',
    'https://i.postimg.cc/C5JGgvgn/flyer2.png',
    'https://i.postimg.cc/WzSGv9vJ/flyer3.png',
    'https://i.postimg.cc/8cwRSySF/flyer4.png',
    'https://i.postimg.cc/Vvzqpx39/flyer5.png',
    'https://i.postimg.cc/fyMcpG6X/flyer6.png',
    'https://i.postimg.cc/L5mtwcrt/flyer7.png',
    'https://i.postimg.cc/fyMcpG6Y/flyer8.png'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
      <Navbar />

      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Sponsorship Information
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6">
              Discover partnership opportunities with the LC Cardinals
            </p>
            <div className="flex items-center justify-center gap-2 text-gray-500 animate-bounce">
              <ChevronDown className="w-5 h-5" />
              <span className="text-sm">Scroll to view all pages</span>
            </div>
          </div>

          <div className="space-y-8">
            {flyers.map((flyer, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all hover:shadow-2xl hover:scale-[1.01] duration-300"
              >
                <img
                  src={flyer}
                  alt={`Sponsorship Information Page ${index + 1}`}
                  className="w-full h-auto"
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
          </div>

          <div className="mt-16 text-center bg-gradient-to-r from-cardinal to-red-700 rounded-2xl p-8 shadow-xl">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ready to Partner With Us?
            </h2>
            <p className="text-white/90 mb-6 max-w-2xl mx-auto">
              Join our family of partners and help support youth baseball in our community
            </p>
            <a
              href="/contact"
              className="inline-flex items-center px-8 py-3 bg-white text-cardinal font-semibold rounded-xl hover:bg-gray-100 transition-colors shadow-lg"
            >
              Get In Touch
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SponsorshipInfo;
